<span id="prestacao-contas"></span>
<div class="content">
    <div>
        <h2>Prestação de contas</h2>
        <p>A prestação de contas do Conselho Municipal da Criança e do Adolescente de Parnamirim, no Rio Grande do Norte, desempenha um papel fundamental na transparência e na responsabilidade na gestão dos recursos e políticas voltadas para a infância e adolescência em nosso município. Este órgão tem a importante missão de fiscalizar, planejar e direcionar os investimentos e ações destinados ao bem-estar das crianças e dos adolescentes em nossa comunidade.</p>
        <ul>
            <li>Plano de ação 2024</li>
            <button (click)="download()">
                <span>Baixe aqui</span>
            </button>
        </ul>
    </div>
    <img src="/assets/images/images/todolist.svg" alt="prestacao de contas">
</div>